import React from 'react';
import { Link } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useTranslation } from "react-i18next";


export interface ISecondaryListItem {
    title: string,
    loading: boolean,
    isSelected: boolean,
    count: number,
    url: string,
    dataComponentName?: string
}

const useStyles = makeStyles({
    root: {
        padding: "0.6vh 30px",
        boxSizing: "border-box",
        color: '#AAB6D3',
        borderRadius: "6px",
        transition: "0.2s ease-in-out",
        "&:hover": {
            background: '#FCFBFD',
        },
        "&.active": {
            background: '#F3F4F9',
            cursor: "default",
            "& $itemText": {
                color: "#2C2C2C",
                fontWeight: 700,
            },
            "& $itemCounter": {
                color: "#2C2C2C",
                fontWeight: 700,
            }
        }
    },
    itemText: {
        fontSize: "2rem",
    },
    itemCounter: {
        border: "1px solid #cccccc",
        borderRadius: "4px",
        padding: "0.2rem 0.8rem",
        fontSize: "0.85rem",
        color: "#8D98B7",
        marginRight: "35px",

    },
    itemCounterActive: {
        border: "1px solid #FFDD02",
        background: "#FAF6E0",
        borderRadius: "4px",
        padding: "0.2rem 0.8rem",
        fontSize: "0.85rem",
        color: "#212121",
        marginRight: "35px",

    }
});

const SecondaryListItem = (props: ISecondaryListItem) => {
    const classNames = useStyles();
    const { t } = useTranslation();
    
    return (
        <Link to={props.url}>
            <ListItem className={`${classNames.root} ${props.isSelected ? 'active' : ''}`}>
                <div data-component-name={props.dataComponentName}>
                    <ListItemText
                        classes={{ primary: classNames.itemText }}
                        primary={
                            props.loading ?
                                <Skeleton animation="wave" /> :
                                t(props.title)
                        }
                    />
                    <ListItemSecondaryAction className={`${props.isSelected?classNames.itemCounterActive:classNames.itemCounter}`}>
                        {
                            props.loading ?
                                <Skeleton animation="wave" /> :
                                props.count
                        }
                    </ListItemSecondaryAction>
                </div>
            </ListItem>
        </Link>
    )
}

export default SecondaryListItem;
